import { OAuthProvider } from '@seapoint/server/enums';

export const allowedOAuthProviders = [OAuthProvider.GMAIL, OAuthProvider.XERO] as const;
export type AllowedOAuthProvider = (typeof allowedOAuthProviders)[number];

type VisibleOAuthProvider = AllowedOAuthProvider | 'slack' | 'quickbooks';
export type OAuthConnectionStatus = 'CONNECTED' | 'DISCONNECTED' | 'COMING_SOON';

export type OAuthProviderConnection =
  | {
      id: Extract<VisibleOAuthProvider, OAuthProvider.GMAIL | OAuthProvider.XERO>;
      status: Extract<OAuthConnectionStatus, 'CONNECTED' | 'DISCONNECTED'>;
    }
  | {
      id: Extract<VisibleOAuthProvider, 'slack' | 'quickbooks'>;
      status: 'COMING_SOON';
    };

export type OAuthConnectionInformation = {
  connected: boolean;
  connectionId?: string;
  email?: string;
  error?: string;
  authUrl?: string;
  createdAt?: string;
  authorisedAt?: string;
  lastVerifiedAt?: string;
};
